import { ActionTree, Dispatch, Commit } from "vuex";
import { SignageAdapterApi } from "@vacancorp/signage.adapter.api.vacanservice.com";
import {
  fetchPlaceListByPlaceIdHashList,
  fetchDisplayVacancyByPlaceIdHashList,
  fetchAreaGenderByPlaceIdHashList,
} from "@/api";

import types from "@/store/types";
import { PlaceState } from "@/store/place/state";

export const actions: ActionTree<PlaceState, any> = {
  [types.place.actions.SETUP]: async (
    { dispatch, commit }: { dispatch: Dispatch; commit: Commit },
    { placeIdHashList }: { placeIdHashList: string[] },
  ): Promise<void> => {
    const [placeList, displayVacancyList,areaGenderList]: [
      SignageAdapterApi.ResponseGetPlace[],
      SignageAdapterApi.ResponseGetDisplayVacancy[],
      SignageAdapterApi.ResponseGetDisplayVacancy[],
    ] = await Promise.all([
      fetchPlaceListByPlaceIdHashList(placeIdHashList),
      fetchDisplayVacancyByPlaceIdHashList(placeIdHashList),
      fetchAreaGenderByPlaceIdHashList(placeIdHashList),
    ]).catch(() => {
      // fallback
      return [[], [], []]; // Not to return void
    });
    commit(types.place.mutations.SET_PLACE_ID_HASH_LIST, placeIdHashList);
    commit(types.place.mutations.SET_DISPLAY_VACANCY_LIST, displayVacancyList);
    commit(types.place.mutations.SET_AREA_GENDER, areaGenderList);
  },
  [types.place.actions.LOOP]: async ({ commit, state }: { commit: Commit; state: PlaceState }): Promise<void> => {
    // Place
    const fetchingPlaceTimer: NodeJS.Timer = setInterval(async () => {
            // 15分に一度の更新 place情報 & エリア性別情報を取得
      const placeList: SignageAdapterApi.ResponseGetPlace[] = await fetchPlaceListByPlaceIdHashList(
        state.placeIdHashList,
      );
      const areaGenderList: SignageAdapterApi.ResponseGetDisplayVacancy[] = await fetchAreaGenderByPlaceIdHashList(
        state.placeIdHashList,
      );
      commit(types.place.mutations.SET_FLOOR_PLAN, placeList);
      commit(types.place.mutations.SET_AREA_GENDER, areaGenderList);
    }, state.intervalToFetchPlace);
    commit(types.place.mutations.SET_FETCHING_PLACE_TIMER, fetchingPlaceTimer);

    // Vacancy
    const fetchingVacancyTimer: NodeJS.Timer = setInterval(async () => {
      const displayVacancyList: SignageAdapterApi.ResponseGetDisplayVacancy[] =
        await fetchDisplayVacancyByPlaceIdHashList(state.placeIdHashList);
      commit(types.place.mutations.SET_DISPLAY_VACANCY_LIST, displayVacancyList);


    }, state.intervalToFetchVacancy);
    commit(types.place.mutations.SET_FETCHING_VACANCY_TIMER, fetchingVacancyTimer);
  },
  [types.place.actions.TEARDOWN]: ({ commit, state }: { commit: Commit; state: PlaceState }): void => {
    if (state.fetchingPlaceTimer) {
      clearTimeout(state.fetchingPlaceTimer);
      commit(types.place.mutations.SET_FETCHING_PLACE_TIMER, undefined);
    }
    if (state.fetchingVacancyTimer) {
      clearTimeout(state.fetchingVacancyTimer);
      commit(types.place.mutations.SET_FETCHING_VACANCY_TIMER, undefined);
    }
  },
};
